import { motion } from "framer-motion";
import SectionHeader from "./SectionHeader";

const SCHEDULE = [
  { day: "Day 1", time: "09:00", title: "Opening & Keynote", note: "Inauguration and welcome address." },
  { day: "Day 1", time: "10:00", title: "IPL Mega Auction", note: "The Assembly of Champions — franchise auction floor." },
  { day: "Day 1", time: "11:30", title: "Shark Tank", note: "The Council of Titans — pitches before the investor panel." },
  { day: "Day 1", time: "13:30", title: "Market Mayhem", note: "The Marketplace of Olympus — live simulated trading." },
  { day: "Day 1", time: "15:00", title: "Consumer Court of Justice", note: "The Court of Athena — oral arguments and verdicts." },
  { day: "Day 1", time: "16:30", title: "Crisis Cabinet", note: "The Trial of the Gods — war-room crisis simulation." },
  { day: "Day 1", time: "18:00", title: "Reel Cheney", note: "The Muses of Motion — brand reel showdown." },
  { day: "Day 1", time: "19:30", title: "Awards & Closing", note: "Crowning of the Titans." },
];

export default function Schedule() {
  return (
    <section id="schedule" data-testid="schedule-section" className="relative py-20 sm:py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-12">
        <SectionHeader
          eyebrow="Schedule"
          title={<><span className="text-marble">One Day. </span><span className="italic text-gold-gradient">Six Acts.</span></>}
          align="center"
          testId="schedule-header"
        />

        <div className="relative mt-12 md:mt-16">
          {/* Vertical line: left on mobile, center on md+ */}
          <div className="absolute left-2 md:left-1/2 top-0 bottom-0 w-px bg-[#B8873B]/30" />

          <div className="space-y-8 md:space-y-12">
            {SCHEDULE.map((item, i) => {
              const isLeft = i % 2 === 0;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  className="relative md:grid md:grid-cols-2 md:gap-10 pl-8 md:pl-0"
                  data-testid={`schedule-item-${i}`}
                >
                  <span className="absolute left-2 md:left-1/2 -translate-x-1/2 top-1.5 w-2.5 h-2.5 rounded-full bg-[#B8873B] pulse-dot" />

                  {/* Mobile: all content here; md+: alternate left/right */}
                  <div className={`md:hidden`}>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8873B]/70">{item.day}</div>
                    <div className="mt-1 font-display text-xl text-marble">{item.title}</div>
                    <p className="mt-2 text-white/55 text-sm leading-relaxed">{item.note}</p>
                  </div>

                  <div className={`hidden md:block ${isLeft ? "md:pr-10 md:text-right" : "md:col-start-2 md:pl-10"}`}>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8873B]/70">{item.day}</div>
                    <div className="mt-1 font-display text-2xl text-marble">{item.title}</div>
                    <p className="mt-2 text-white/55 text-sm">{item.note}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
